module.exports = __webpack_public_path__ + "img/arena-1758.88e0c0bc.png";